<script lang="ts">
	import { focusAreas } from '$lib/focus-areas';
</script>

<section id="focus" class="section focus" aria-labelledby="focus-heading">
	<div class="container">
		<div class="section-intro focus-intro">
			<p class="eyebrow">Practice</p>
			<h2 id="focus-heading">Focus</h2>
			<div class="section-rule" aria-hidden="true"></div>
			<p class="section-subtitle">
				The work that has to hold up in production — infrastructure, identity, applications, and the
				systems that keep them available.
			</p>
		</div>

		<ol class="practice-list">
			{#each focusAreas as area, index (area.title)}
				<li class="practice-item">
					<span class="practice-index" aria-hidden="true">
						{String(index + 1).padStart(2, '0')}
					</span>
					<div class="practice-body">
						<h3>{area.title}</h3>
						<p>{area.description}</p>
					</div>
				</li>
			{/each}
		</ol>
	</div>
</section>
